const initialState = {
  records: {},
  autoSaveData: [],
  autoSaveFileData: {}

};
export const dashboard = (state = initialState, action) => {
  switch (action.type) {
    case "DASHBOARD_DATA": {
      return { ...state, records: action.data.records };
    }
    case "SET_AUTOSAVE_DATA": {
      return { ...state, autoSaveData: action.data };
    }
    case "SET_AUTOSAVE_FILE_DATA": {
      return { ...state, autoSaveFileData: action.data };
    }

    case "APPEND_QUEUE_LIST": {
      if (state?.records?.docs) {
        let docRecords = state?.records?.docs;
        let docList = [...docRecords, ...action.data.docs];
        action.data.docs = docList;
        return { ...state, records: action.data };
      } else {
        return state;
      }

    }

    case "LOGOUT":
      return initialState;
    default:
      return state;
  }
};
